import { render, staticRenderFns } from "./CuadroMandoSGA.vue?vue&type=template&id=4cf08526&scoped=true"
import script from "./CuadroMandoSGA.vue?vue&type=script&lang=js"
export * from "./CuadroMandoSGA.vue?vue&type=script&lang=js"
import style0 from "./CuadroMandoSGA.vue?vue&type=style&index=0&id=4cf08526&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf08526",
  null
  
)

export default component.exports